<div id="app">
  <nav class="navbar navbar-expand-lg app-navbar" *ngIf="shouldShowMainNavbar()">
    <div class="container-fluid app-navbar-shell">
      <button class="navbar-toggler app-navbar-toggler" type="button" (click)="myFunction()" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav app-navbar-nav">
          <li class="nav-item" routerLinkActive="app-nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link app-nav-link" routerLink="/admin" *ngIf="showAdminBoard">Global</a>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link app-nav-link" routerLink="/my-board" *ngIf="showStudentBoard">Mon bord</a>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link app-nav-link" routerLink="/monitor-calendar" *ngIf="showMonitorBoard && (!showAdminBoard || isReadOnly)">Mon Plannig</a>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active">
            <a class="nav-link app-nav-link" routerLink="/calendar" *ngIf="showAdminBoard">Calendrier</a>
            <a class="nav-link app-nav-link" routerLink="/my-calendar" *ngIf="showStudentBoard">Mes Heures</a>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active">
            <a class="nav-link app-nav-link" routerLink="/my-drive" *ngIf="showStudentBoard">Suivi Drive</a>
          </li>
          <li class="nav-item dropdown" *ngIf="showAdminBoard">
            <a class="nav-link dropdown-toggle app-nav-link" id="student-navbar" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Eléves
            </a>
            <div class="dropdown-menu app-dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item app-dropdown-item" routerLink="/students">Liste des éléves</a>
              <a class="dropdown-item app-dropdown-item" routerLink="/new-student" *ngIf="!isReadOnly">Créé un éléve</a>
              <a class="dropdown-item app-dropdown-item" routerLink="/students-archived">Elèves archivés</a>
            </div>
          </li>
          <li class="nav-item dropdown" *ngIf="showAdminBoard">
            <a class="nav-link dropdown-toggle app-nav-link" id="monitor-navbar" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Équipe
            </a>
            <div class="dropdown-menu app-dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item app-dropdown-item" routerLink="/monitors">Liste des moniteurs</a>
              <div class="dropdown-divider" *ngIf="!isReadOnly"></div>
              <a class="dropdown-item app-dropdown-item" routerLink="/users" *ngIf="!isReadOnly">Comptes utilisateurs</a>
            </div>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active">
            <a class="nav-link app-nav-link" routerLink="/configurations" *ngIf="showAdminBoard">Configurations</a>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active">
            <a class="nav-link app-nav-link" routerLink="/payments" *ngIf="showAdminBoard && isSuperAdmin">Paiements</a>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active">
            <a class="nav-link app-nav-link" routerLink="/purchases" *ngIf="showAdminBoard">Dépenses</a>
          </li>
          <li class="nav-item" routerLinkActive="app-nav-item-active">
            <a class="nav-link app-nav-link" routerLink="/events-history" *ngIf="showAdminBoard">Historique</a>
          </li>
          <li class="nav-item">
            <a class="nav-link app-nav-link app-nav-link--accent" *ngIf="showAdminBoard && !isReadOnly" data-toggle="modal" data-target="#expenseModal">
              <i class="fa fa-plus" aria-hidden="true"></i> Ajouter Dépense
            </a>
          </li>
          <a class="nav-link app-nav-link app-nav-link--right" routerLink="/login" *ngIf="!isLoggedIn && navMobile">Connexion</a>
          <a class="nav-link app-nav-link app-nav-link--right" routerLink="/profile" *ngIf="isLoggedIn && navMobile">{{ username }}</a>
          <a href class="nav-link app-nav-link app-nav-link--right" (click)="logout()" *ngIf="isLoggedIn && navMobile">Se Déconnecter</a>
        </ul>
      </div>
      <form class="form-inline app-navbar-actions" *ngIf="!navMobile">
        <a class="nav-link app-nav-link app-nav-link--right" routerLink="/login" *ngIf="!isLoggedIn">Connexion</a>
        <a class="nav-link app-nav-link app-nav-link--right" routerLink="/profile" *ngIf="isLoggedIn">{{ username }}</a>
        <a href class="nav-link app-nav-link app-nav-link--right" (click)="logout()" *ngIf="isLoggedIn">Se Déconnecter</a>
      </form>
    </div>
  </nav>

  <router-outlet></router-outlet>

  <!-- Modal -->
  <div class="modal fade" id="expenseModal" tabindex="-1" role="dialog" aria-labelledby="expenseModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="expenseModalLabel">Ajouter une dépense</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="expenseForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="date">Date</label>
              <input type="date" class="form-control" id="date" formControlName="date">
            </div>
            <div class="form-group">
              <label for="product">Mode de paiement</label>
              <select class="form-control" id="payment" formControlName="paymentMethod">
                <option *ngFor="let payment of paymentMethods" [value]="payment">{{ payment }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="price">Prix</label>
              <input type="number" class="form-control" id="price" formControlName="cost" placeholder="Quel est le montant ?">
            </div>
            <div class="form-group">
              <label for="product">Raison</label>
              <select class="form-control" id="product" formControlName="reason">
                <option *ngFor="let product of products" [value]="product">{{ product }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="description">Description</label>
              <textarea class="form-control" id="description" formControlName="description" rows="3"></textarea>
            </div>
            <button type="submit" class="btn btn-primary">Enregistrer</button>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>


</div>
